export enum APPOINTMENT_STATUS {
    CANCELLED = 'CN',
    ABORTED = 'AB',
    NO_SHOW = 'NS',
    NO_SHOW_DOCTOR = 'NSD',
    NO_SHOW_STAFF = 'NSS',
    COMPLETED = 'CM',
    RESCHEDULED = 'RE',
    ONGOING = 'OG',
    BOOKED = 'BK',
    PARKED = 'PA',
    PROVISIONAL_CANCELLED = 'PC',
    COMPLETED_NO_PRESCRIPTION = 'CMNP',
    DOCTOR_RESCHEDULED = 'RED',
    DOCTOR_CANCELLED = 'CND',
    STAFF_RESCHEDULED = 'RES',
    STAFF_CANCELLED = 'CNS',
    PAYMENT_NOT_RECEIVED = 'PNR',
    INITIATED = 'IN',
    RESERVED = 'RV',
    CHECKED_IN = 'CK',
}

export const todayQueueStatus = [
    APPOINTMENT_STATUS.ONGOING,
    APPOINTMENT_STATUS.BOOKED,
    APPOINTMENT_STATUS.CHECKED_IN,
    APPOINTMENT_STATUS.PARKED,
];
export const completedQueueStatus = [
    APPOINTMENT_STATUS.COMPLETED,
    APPOINTMENT_STATUS.COMPLETED_NO_PRESCRIPTION,
];
export const upcomingQueueStatus = [
    APPOINTMENT_STATUS.ONGOING,
    APPOINTMENT_STATUS.BOOKED,
    APPOINTMENT_STATUS.CHECKED_IN,
    APPOINTMENT_STATUS.PARKED,
];
export const otherQueueStatus = [
    APPOINTMENT_STATUS.CANCELLED,
    APPOINTMENT_STATUS.STAFF_CANCELLED,
    APPOINTMENT_STATUS.DOCTOR_CANCELLED,
    APPOINTMENT_STATUS.RESCHEDULED,
    APPOINTMENT_STATUS.STAFF_RESCHEDULED,
    APPOINTMENT_STATUS.DOCTOR_RESCHEDULED,
    APPOINTMENT_STATUS.ABORTED,
    APPOINTMENT_STATUS.NO_SHOW,
    APPOINTMENT_STATUS.NO_SHOW_DOCTOR,
    APPOINTMENT_STATUS.NO_SHOW_STAFF,
];
export const followupQueueStatus = [
    APPOINTMENT_STATUS.INITIATED,
    APPOINTMENT_STATUS.RESERVED,
    APPOINTMENT_STATUS.PROVISIONAL_CANCELLED,
    // APPOINTMENT_STATUS.BOOKED,
    APPOINTMENT_STATUS.RESCHEDULED,
];
